module.exports = global["jQuery"] = require("-!/Users/caojiabao/Documents/Projects/GIT/nowness-frontend-new/node_modules/jquery/src/jquery.js");


//////////////////
// WEBPACK FOOTER
// ../~/expose-loader?jQuery!../~/jquery/src/jquery.js
// module id = 370
// module chunks = 0